/**
 * Query key factory for reference data. One read today — the presentation
 * table has no parameters, so it is one cache entry app-wide.
 */
export const referenceKeys = {
  all: ['reference'] as const,
  metricPresentations: () => [...referenceKeys.all, 'metric-presentations'] as const,
}
